const SIDEBAR_ICONS = {
    'referral': <img src='/assets/referrals-icon.png' alt="Referrals" className='menu-icon'/>,
    'cassette': <img src='/assets/vhs-icon.png' alt="VHS" className='menu-icon'/>,
    'admin': <img src='/assets/admin-icon.png' alt="Admins" className='menu-icon'/>,
    'program-engine': <img src='/assets/pe-icon.png' alt="Program Engine" className='menu-icon'/>,
    'community': <img src='/assets/cs-icon.png' alt="Community" className='menu-icon'/>,
    'logout': <img src='/assets/logout-icon.png' alt="Log Out" className='menu-icon'/>
};

export default SIDEBAR_ICONS;